// prefers-reduced-motion: reduce
export const prefersReducedMotion =
  typeof window !== 'undefined'
    ? window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
    : false;

const variables = {
  pageTransitionDuration: prefersReducedMotion ? 1 : 400,
  smallMobileBreakpoint: 375,
  mobileBreakpoint: 896,
  desktopBreakpoint: 1024,
  smallDesktopHeight: 768,
}; // same as shareVariables.scss

export default variables;
